import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { Avatar } from 'primereact/avatar';
import * as constantes from "../../../constants/constantes.js";
import { Button } from 'primereact/button';

import "./CardAniversario.scss";

//const CardBuscarPublicacion = ({ onFiltrar   }) => {
const CardBuscarPublicacion = ({ onBuscar, onInicio }) => {

    const [searchText, setSearchText] = useState("");
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaFin, setFechaFin] = useState(null);

    const handleBuscar = () => {
        onBuscar({
            texto: searchText,
            fechaInicio,
            fechaFin
        });

        // 🔥 LIMPIAR CAMPOS DESPUÉS DE BUSCAR
        setSearchText("");
        setFechaInicio(null);
        setFechaFin(null);
    };

    const handleLimpiar = () => {
        setSearchText("");
        setFechaInicio(null);
        setFechaFin(null);
        onInicio();
    };

    const header =
        <div className='p-eva-header-cumpleanios' style={{  padding: "13px",  width: "100%", textAlign: "center" }}>            
            <label  className='header-subtitle'>Buscar Publicaciones</label>
        </div>;

    return (
        <Card header={header} className="p-eva-cardAniversario">

            {/* CONTROLES DE BÚSQUEDA */}
            <div className="p-fluid grid mb-3" style={{ padding: 10 }}>                
                <div className="col-12">                           
                    <span className="p-input-icon-left" style={{ width: "100%" }}>
                        {/* <i className="pi pi-search" /> */}
                         <label>Buscar por texto</label>
                        <InputText
                            placeholder="Buscar por texto..."
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            style={{ width: "100%" }}
                        />
                    </span>
                </div>
                <div className="col-12">
                    <span className="p-input-icon-left" style={{ width: "100%" }}>                        
                         <label>Buscar por Fechas</label>                        
                    </span>
                </div>
                <div className="col-6">
                    <Calendar
                        value={fechaInicio}
                        onChange={(e) => setFechaInicio(e.value)}
                        placeholder="inicio"
                        dateFormat="dd/mm/yy"
                        showIcon
                        style={{ width: "100%" }}
                        className="calendar-orange"
                    />
                </div>

                <div className="col-6">
                    <Calendar
                        value={fechaFin}
                        onChange={(e) => setFechaFin(e.value)}
                        placeholder="fin"
                        dateFormat="dd/mm/yy"
                        showIcon
                        style={{ width: "100%" }}
                        className="calendar-orange"
                    />
                </div>                
                <div className="col-6">
                    <Button
                        label="Refrescar"
                        icon="pi pi-home"
                        className="btn-pill btn-pill-gray"
                        onClick={handleLimpiar}
                    />
                </div>
                <div className="col-6">
                    <Button
                        label="Buscar"
                        icon="pi pi-search"
                        className="btn-pill btn-pill-orange"                        
                        onClick={handleBuscar}
                    />
                </div>
            </div>
           
        </Card>
    );
}

export default CardBuscarPublicacion;
